import { defineMessages } from 'react-intl'

export default defineMessages({
  assignTitle: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.assignTitle',
    defaultMessage: 'Add Task Supplier',
  },
  reAssignTitle: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.reAssignTitle',
    defaultMessage: 'Reassign supplier',
  },
  briefTemplateVO: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.voiceover',
    defaultMessage: `
Check production information for important info!

Style:

Reference file:

Pronunciation:

Recording pace:

Recording specifics:
    `,
  },
  briefTemplateLSA: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.livesessionaudio',
    defaultMessage: `
Hi,

We will do the online live session on XXX. You'll receive an invite in your calendar with a link to join.

Please join 5-10 mins before, so that we can check the sound before the client arrives.

The session will take place at your end as usual, and once the session is completed you need to clean and upload your files in the system as you would for any other job.
Please make sure not to share any personal details or contact info with the client. All file exchange and further communication will be handled through the VoiceArchive platform.

If you have any questions, please feel free to reach out to me anytime.

Talk to you on XXX

Best,
{name}
    `,
  },
  briefTemplateLSP: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.livesessionplayback',
    defaultMessage: `Hello,
We will be holding the Live Session Playback on XXXXX. A link to join the session will be sent to you in a separate email. Please log in 5-10 minutes before the session begins to ensure your connection is working properly.
It is important that you log into the session using your VoiceArchive userid - not your own name.

As this is an Live Session Playback, our post producer will connect with your recording setup before we start. We will use the link you receive to establish this connection. If you haven't done this before, please let me know.

For Sessions with Video:
If your session involves running a video, please ensure that the computer displaying the video is in the same room as your microphone.

If you have any questions, feel free to reach out. Otherwise, we'll talk during the session.`,
  },
  briefTemplateUSAGE: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.usage',
    defaultMessage: `
Hi,

This is the 'Usage' task valid for the conditions stated in the left-hand sidebar.

By approving this task, you acknowledge and accept these terms.

Note that you need to approve this task to receive your payment.

Best,
{name}
    `,
  },
  briefTemplateNPR: {
    id: 'containers.OrderPage.components.TaskPage.components.AddTaskSupplierDialog.templates.briefTemplateNPR',
    defaultMessage: `
Hi,

We have a new Native Post Producer session for you.
The session will take place at XXX
Please login 10 minutes before the session to make sure that the connection is working.
We will send you login details to the session in a separate email.

You will be the Native Post Producer on this session together with the talent and client.

Have a good session

Best regards,
{name}
    `,
  }
})
